import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import userReducer from "./slices/userSlice";
import filterReducer from "./slices/filterSlice";

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"], // You can choose which reducer to persist (e.g., 'user')
};

// Combine reducers
const rootReducer = combineReducers({
  user: userReducer,
  filter: filterReducer,
});

// Persist the rootReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disables the warning about non-serializable values in the state (needed for redux-persist)
    }),
});

// Create a persistor
export const persistor = persistStore(store);
